<script>
import IConstants from '@/common/constants/IConstants'

export default {
    name: "PasswordMixins",
    methods: {
        checkPasswordRelatedInformation(input, password) {
            if (input.includes(IConstants.VALIDATE_PASSWORD.CHECK_MAIL)) {
                input = input.split(IConstants.VALIDATE_PASSWORD.CHECK_MAIL)[0];
            }

            let countCharSame = IConstants.MAX_LENGTH.VALIDATE_PASSWORD;
            if (input.length >= countCharSame) {
                let inputSub;
                for (let i = 0; i <= input.length - countCharSame; i++) {
                    inputSub = input.substring(i, i + countCharSame);
                    if (password.toLowerCase().includes(inputSub.toLowerCase())) {
                        return true;
                    }
                }
            }
            return false;
        },
    }
}
</script>

